<template>
  <div>
    <datatable
      title="Admin Languages"
      @delete="deleteLanguage"
      @create="createLanguage"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-languages',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'language_code',
          value: 'language_code'
        },
        {
          name: 'name',
          value: 'name'
        }
      ],
      data: [],
      operations: []
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    deleteLanguage (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.name,
        item_name: delete_data.name,
        method: 'deleteLanguage',
        method_params: { id: delete_data.id }
      })
    },
    createLanguage () {
      this.create({ designator: 'admin-language-form-modal', component_name: 'AdminLanguagesForm', is_create: true, modal_title: 'Create new Language' })
    },
    init () {
      this.$network_utils.getAllLanguages().then(response => {
        this.data = response
      })
    },
    editClick (data) {
      this.create({ designator: 'admin-language-form-modal', component_name: 'AdminLanguagesForm', data, modal_title: data.name })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
